var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@web/components/layout/Button';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import Table from '@web/components/layout/Table/Table';
import { TableSortIcons } from '@web/components/layout/Table/TableSortIcons';
import { widgetMetricTableColMetricValueStyle, widgetMetricTableFigureValueSpanClass, widgetMetricTablePairHeaderThClass, widgetMetricTablePrimaryLabelTdClass, widgetMetricTableValueCellInnerClass, widgetMetricTableValueTdClass } from '@web/components/layout/WidgetTable/widgetMetricCellClasses';
import { metricTablePeriodDiffRowCell } from '@web/components/layout/WidgetTable/widgetMetricTableCells';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { TablesDiffColorsConfig } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { classNames, isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { navigateToDriveAdvancedSearch } from '@web/utility/chartNavigation';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { SortOrderEnum } from '@workalizer/shared';
import { WIDGET_TABLE_INITIAL_ROWS, WIDGET_TABLE_LOAD_MORE_ROWS } from '@workalizer/shared/config';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
var mostPopularDocsValueDiffPair = [
    widgetMetricTableColMetricValueStyle,
    { width: '11%', minWidth: '5.125rem' }
];
var mostPopularDocumentsTableColgroup = __spreadArray(__spreadArray(__spreadArray(__spreadArray([
    { width: '32%', minWidth: '11rem' }
], mostPopularDocsValueDiffPair, true), mostPopularDocsValueDiffPair, true), mostPopularDocsValueDiffPair, true), mostPopularDocsValueDiffPair, true);
var metricSortColumns = [
    {
        field: 'views',
        labelKey: 'app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.views'
    },
    {
        field: 'edits',
        labelKey: 'app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.edits'
    },
    {
        field: 'comments',
        labelKey: 'app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.comments'
    },
    {
        field: 'downloads',
        labelKey: 'app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.downloads'
    }
];
var metricColumnIndexByField = Object.fromEntries(metricSortColumns.map(function (column, index) { return [column.field, index + 1]; }));
export var MostPopularDocuments = function (_a) {
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var navigationScope = {
        navigateTo: navigateTo,
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: userId,
        orgUnitId: orgUnitId
    };
    var navigateToDocumentSearch = function (title) {
        navigateToDriveAdvancedSearch(navigationScope, {
            driveSearchTitle: title
        });
    };
    var _b = useState(WIDGET_TABLE_INITIAL_ROWS), displayedCount = _b[0], setDisplayedCount = _b[1];
    var _c = useState({
        field: 'views',
        direction: SortOrderEnum.DESC
    }), sortBy = _c[0], setSortBy = _c[1];
    var _d = trpc.mostPopularDocuments.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }), mostPopularDocumentsData = _d.data, isLoading = _d.isLoading, refetch = _d.refetch;
    if (isLoading) {
        return _jsx(Loading, {});
    }
    var sortDirection = sortBy.direction === SortOrderEnum.ASC ? 1 : -1;
    var sortedMostPopularDocumentsData = __spreadArray([], (mostPopularDocumentsData !== null && mostPopularDocumentsData !== void 0 ? mostPopularDocumentsData : []), true).sort(function (a, b) {
        return sortDirection *
            (a.currentPeriod[sortBy.field] - b.currentPeriod[sortBy.field]);
    });
    var displayedMostPopularDocumentsData = sortedMostPopularDocumentsData.slice(0, displayedCount);
    var hasMore = sortedMostPopularDocumentsData.length > displayedCount;
    var headerMetricClass = "".concat(widgetMetricTablePairHeaderThClass, " cursor-pointer");
    var columns = __spreadArray([
        {
            title: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.documentName'),
            isVisible: true,
            className: 'min-w-0 !text-left'
        }
    ], metricSortColumns.map(function (_a) {
        var field = _a.field, labelKey = _a.labelKey;
        return ({
            title: (_jsxs("span", __assign({ className: "inline-flex items-center gap-1" }, { children: [t(labelKey), _jsx(TableSortIcons, { isActive: sortBy.field === field, direction: sortBy.direction })] }))),
            isVisible: true,
            colspan: 2,
            className: headerMetricClass,
            orderByField: field
        });
    }), true);
    var tableData = displayedMostPopularDocumentsData.map(function (item) {
        var rk = String(item.id);
        var metricCells = function (current, periodDiff, prefix, title) { return [
            {
                id: "".concat(prefix, "-value-").concat(rk),
                className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerClass, 'cursor-pointer'), onClick: function () { return navigateToDocumentSearch(title); } }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanClass }, { children: current })) }))); }
            },
            metricTablePeriodDiffRowCell("".concat(prefix, "-period-").concat(rk), periodDiff, TablesDiffColorsConfig.GREEN)
        ]; };
        return __spreadArray(__spreadArray(__spreadArray(__spreadArray([
            {
                id: "title-".concat(rk),
                className: "".concat(widgetMetricTablePrimaryLabelTdClass, " !pr-4"),
                render: function () { return (_jsx("div", __assign({ className: "min-w-0 max-w-full cursor-pointer break-words font-semibold underline decoration-dashed underline-offset-2 decoration-gray-400 hover:text-indigo-600 hover:decoration-indigo-600", onClick: function () { return navigateToDocumentSearch(item.title); } }, { children: item.title }))); }
            }
        ], metricCells(item.currentPeriod.views, item.previousPeriod.views, 'views', item.title), true), metricCells(item.currentPeriod.edits, item.previousPeriod.edits, 'edits', item.title), true), metricCells(item.currentPeriod.comments, item.previousPeriod.comments, 'comments', item.title), true), metricCells(item.currentPeriod.downloads, item.previousPeriod.downloads, 'downloads', item.title), true);
    });
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.mostPopularDocuments'), description: t('widgetTitleDescriptions.initiativeAndOwnership.mostPopularDocuments'), insightType: InsightTypeEnum.mostPopularDocuments, insightsData: displayedMostPopularDocumentsData, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.mostPopularDocuments'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, displayedMostPopularDocumentsData.map(function (item) {
                                    var _a;
                                    return (_a = {},
                                        _a[t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.documentName')] = item.title,
                                        _a[t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.views')] = item.currentPeriod.views,
                                        _a[t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.edits')] = item.currentPeriod.edits,
                                        _a[t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.comments')] = item.currentPeriod.comments,
                                        _a[t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.downloads')] = item.currentPeriod.downloads,
                                        _a);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(displayedMostPopularDocumentsData) }) }), _jsx(Table, { data: isInsightsDataEmpty(displayedMostPopularDocumentsData)
                    ? []
                    : tableData, columns: columns, columnColStyles: mostPopularDocumentsTableColgroup, tableClassName: "table-auto w-full", rowClassName: "[&>td]:align-top", sortingOption: {
                    show: true,
                    elementIndex: metricColumnIndexByField[sortBy.field],
                    orderByField: sortBy.field,
                    direction: sortBy.direction,
                    orderByDirection: sortBy.direction
                }, setSortingOption: function (_a) {
                    var orderByField = _a.orderByField, direction = _a.direction;
                    return setSortBy({
                        field: orderByField,
                        direction: direction
                    });
                } }), hasMore && (_jsx("div", __assign({ className: "mt-4 flex justify-center" }, { children: _jsx(Button, __assign({ variant: "link", onClick: function () {
                        return setDisplayedCount(function (prev) { return prev + WIDGET_TABLE_LOAD_MORE_ROWS; });
                    } }, { children: t('loadMore') })) })))] })));
};
